import { Component, OnDestroy } from '@angular/core';
import { DEFAULT_DOC_CHAT_ACTIONS } from '../pojo/utils';
import { MarkdownComponent } from 'ngx-markdown';
import { SharedComponentsModule } from '../../../shared/module/shared-components.module';
import { FormControl, Validators } from '@angular/forms';
import { DocumentsAiService } from '../service/documents-ai.service';
import { AiButtonComponent } from '../../../shared/component/buttons/ai-button/ai-button.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BoxAiRequestDto } from '../pojo/BoxAiRequestDto';
import { AvatarIconComponent } from '../../../profile/component/avatar-icon/avatar-icon.component';
import { AutoScrollDirective } from '../../../../util/directives/auto-scroll.directive';
import { firstValueFrom, Subject } from 'rxjs';
import { AiHistoryMessage, MessageType } from '../../../global-ai/utils';
import { AI_STRINGS } from "../../../ai/utils";

@Component({
  selector: 'app-document-chat',
  standalone: true,
  imports: [
    MarkdownComponent,
    SharedComponentsModule,
    AvatarIconComponent,
    AiButtonComponent,
    AutoScrollDirective,
  ],
  templateUrl: './document-chat.component.html',
  styleUrl: './document-chat.component.scss',
})
export class DocumentChatComponent implements OnDestroy {
  inputControl: FormControl<string>;
  actions = DEFAULT_DOC_CHAT_ACTIONS;
  messages: AiHistoryMessage[];
  autoScrollReset$ = new Subject<void>();
  protected readonly MessageType = MessageType;
  protected readonly AiStrings = AI_STRINGS;

  constructor(private docsAiService: DocumentsAiService) {
    this.initForm();
    this.initSubscriptions();
    this.docsAiService.fetchConversationHistory();
  }

  ngOnDestroy(): void {
    this.docsAiService.cancelActiveRequest();
    this.docsAiService.clearObservables();
  }

  sendRequest(userInput: string): void {
    const text = userInput?.trim();
    if (!text) {
      return;
    }
    this.inputControl.reset();
    this.docsAiService.sendRequest(
      new BoxAiRequestDto(text, this.docsAiService.getSelectedFile().id)
    );
  }

  async clearChat(): Promise<void> {
    await firstValueFrom(this.docsAiService.clearChat());
  }

  private initForm(): void {
    this.inputControl = new FormControl<string>('', Validators.required);
  }

  private initSubscriptions(): void {
    this.docsAiService.messages$
      .pipe(takeUntilDestroyed())
      .subscribe((messages: AiHistoryMessage[]) => {
        this.messages = messages;
      });
  }
}
